import { vtoConstants } from './VTOConstants';

const initialState = {
    workLocations: [],
    offersTable: {},
    offerDetail: {},
    showSearchLoader: false,
    showConfirmationLoader: false,
    submitRequestSuccessful: null,
    confirmedBatch:{},
    batchSubmitted: [],
    showConfirmData:false,
    employeeReqBatch: {},
    empShifts: {},
    manualEmpShifts: {},
    showChangeLogLoader: false,
    changeLogData: [],
    apiError: {},
    requestsBundle: {},
    requestSubSuccess: null,
    actionSuccess: false,
    slotsUpdateSuccess: null,
    resolutionSuccess: null,
    stationListSuccess: null,
    stationList: [],
    editCutOffSuccess: null,
    fetchSuccess: null,
    fetchError: null
}


export const VTOReducer = (state= initialState, action) => {
    switch(action.type) {
        case vtoConstants.GET_WORK_LOC_SUCCESS: {
            return{
                ...state,
                workLocations: action.station
            }
        }

        case vtoConstants.SHOW_LOADER: {
            return {
                ...state,
                showSearchLoader: action.data
            }
        }
        
        case vtoConstants.OFFERS_TABLE_SUCCESS: {
            return{
                ...state,
                offersTable: {... action.data},
                fetchSuccess: true,
                fetchError: null            
            }
        }

        case vtoConstants.OFFERS_TABLE_FAILED: {
            return{
                ...state,
                offersTable: {},
                fetchSuccess: false,
                fetchError: action.data
            }
        }

        case vtoConstants.OFFER_DETAIL_SUCCESS: {
            return {
                ...state,
                offerDetail: action.data
            }
        }

        case vtoConstants.CLEAN_UP: {
            return {
                ...state,
                offersTable: {},
                showConfirmData: false,
                confirmedBatch : {},
                batchSubmitted: [],


            }
        }

        case vtoConstants.SUBMIT_REQUEST_SUCCESS: {
            return {
                ...state,
                submitRequestSuccessful: true
            }
        }

        case vtoConstants.CREATE_OFFERS_RESPONSE_SUCCESS: {
            return {
                ...state,
                confirmedBatch : action.data.payload,
                showConfirmData: true,
                batchSubmitted: action.data.response
            }
        }

        case vtoConstants.SUBMIT_RESPONSE_SUCCESS: {
            return {
                ...state,
                confirmedBatch : action.data.response,
                showConfirmData: true,
                 batchSubmitted: action.data.payload.requests
            }
        }

        case vtoConstants.GET_EMP_REQ_SUCCESS: {
            return {
                ...state,
                employeeReqBatch: action.data,
            }
        }

        case vtoConstants.GET_EMP_SHIFT_SUCCESS: {
          
            let addEmpShifts = {};
            if (action.data?.employeeShifts.length >0) {
                action.data?.employeeShifts.forEach((shift)=>{
                    if (addEmpShifts[shift.shiftDate]) {
                            addEmpShifts[shift.shiftDate].push({...shift, isChecked: true});
                    } else {
                        addEmpShifts[shift.shiftDate]=[{...shift, isChecked: true}]
                    }
                })
            }
            const manual = state.manualEmpShifts || {};
            Object.keys(manual).forEach(date => {
                if (addEmpShifts[date]) {
                    addEmpShifts[date] = [...addEmpShifts[date], ...manual[date]];
                } else {
                    addEmpShifts[date] = [...manual[date]];
                }
            });
            return {
                ...state,
                empShifts: addEmpShifts
            }
        }
        case vtoConstants.ADD_MANUAL_SHIFT: {
            const { date, shift } = action.payload;
            const manualId = shift.manualId || `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
            const newShift = { ...shift, manualId };
            const prev = (state.manualEmpShifts && state.manualEmpShifts[date]) ? state.manualEmpShifts[date] : [];
            return {
                ...state,
                manualEmpShifts: {
                    ...state.manualEmpShifts,
                    [date]: [...prev, newShift]
                }
            };
        }
        case vtoConstants.DELETE_MANUAL_SHIFT: {
            const { date, idx } = action.payload;
            const prev = (state.manualEmpShifts && state.manualEmpShifts[date]) ? state.manualEmpShifts[date] : [];
            const newManual = {
                ...state.manualEmpShifts,
                [date]: prev.filter(s => s.manualId !== idx)
            };
            const prevEmp = (state.empShifts && state.empShifts[date]) ? state.empShifts[date] : [];
            const newEmp = prevEmp.filter(s => !(s.isManual && s.manualId === idx));
            return {
                ...state,
                manualEmpShifts: newManual,
                empShifts: {
                    ...state.empShifts,
                    [date]: newEmp
                }
            };
        }
        case vtoConstants.SHOW_ERROR : {
            return {
                ...state,
                apiError: action.data
            }
        }

        case vtoConstants.GET_REQ_BUNDLE_SUCCESS : {
            return {
                ...state,
                requestsBundle: action.data
            }
        }

        case vtoConstants.SUBMIT_CONFIRM_REQUEST_SUCCESS : {
            return {
                ...state,
                requestSubSuccess: action.data
            }
        }

        case vtoConstants.ACTION_REQUEST_SUCCESS: {
            return {
                ...state,
                actionSuccess: action.data
            }
        }

        case vtoConstants.UPDATE_SLOTS_SUCCESS: {
            return {
                ...state,
                slotsUpdateSuccess: action.data?.response,
                slotsUpdateError: action.data?.response ? null : {title: action.data?.title, detail: action.data?.detail}
            }
        }

        case vtoConstants.SUBMIT_REQ_RESOLUTION_SUCCESS: {
            return {
                ...state,
                resolutionSuccess: action.data
            }
        }

        case vtoConstants.GET_CHANGE_LOG_SUCCESS: {
            return {
                ...state,
                showChangeLogLoader: action.data,
            }
        }

        case vtoConstants.GET_CHANGE_LOG_RESPONSE: {
            return {
                ...state,
                changeLogData: action.data.offerChanges,
            }
        }

        case vtoConstants.GET_VTO_STATION_LIST_SUCCESS: {
            return {
                ...state,
                stationListSuccess: action.data
            }
        }

        case vtoConstants.GET_VTO_STATION_LIST_RESPONSE: {
            return {
                ...state,
                stationList: action.data
            }
        }

        case vtoConstants.SUBMIT_EDIT_CUT_OFF_SUCCESS: {
            return {
                ...state,
                editCutOffSuccess: action.data
            }
        }
        
        default:
      return state;
    }
};

export default VTOReducer;
